import { Injectable } from '@angular/core';
import {
  CompilationResult,
  TranslateMessageFormatCompiler,
} from 'ngx-translate-messageformat-compiler';
import { I18nLanguage } from '@shared/language/language.service';

const CLDR_LOCALE_OVERRIDES: Record<string, string> = {
  [I18nLanguage.UA]: 'uk',
};

@Injectable()
export class MathTranslateMessageFormatCompiler extends TranslateMessageFormatCompiler {
  public override compile<Result extends CompilationResult>(
    value: string,
    lang: string,
  ): Result {
    return super.compile<Result>(value, this.toCldr(lang));
  }

  public override compileTranslations(
    translations: unknown,
    lang: string,
  ): unknown {
    return super.compileTranslations(translations, this.toCldr(lang));
  }

  private toCldr(lang: string): string {
    return CLDR_LOCALE_OVERRIDES[lang] ?? lang;
  }
}
